<template>
  <div :class="!isMobile ? 'container' : ''">
    <div :class="!isMobile ? 'user_profile_form' : 'user_profile_form_mobile'">
      <div class="container">
        <el-card :class="!isMobile ? 'box-card' : ''">
          <div class="c-dialog-head">
            <h4 class="c-dialog-head__title">
              {{ org ? org.organization.short_name || 'Нет данных' : '' }}
            </h4>
            <br />
            <el-button
              v-if="!isMobile"
              type="success"
              icon="el-icon-arrow-left"
              @click="$router.push('/user')"
            >
              Назад к профилю
            </el-button>
          </div>
          <el-row v-if="org.id" :gutter="24">
            <el-col :span="24">
              <p>ИНН: {{ org.organization.inn }}</p>
            </el-col>
          </el-row>
          <el-row v-if="org.id" :gutter="24">
            <el-col :span="24">
              <p><b>БИК Банка</b></p>
            </el-col>
            <el-col :span="24">
              <el-input
                v-model="organization.bik"
                style="width: 40%; margin-right: 15px"
                size="medium"
                placeholder="БИК"
                maxlength="9"
              />
              <el-button size="medium" type="primary" @click="checkBik">
                Проверить БИК
              </el-button>
            </el-col>
            <el-col :span="24">
              <p><b>Название банка</b></p>
            </el-col>
            <el-col :span="24">
              <el-input
                v-model="organization.name_bank"
                type="textarea"
                :rows="3"
                :readonly="true"
                placeholder="Название банка"
              />
            </el-col>
            <el-col :span="24">
              <p><b>Коресподентский счет</b></p>
            </el-col>
            <el-col :span="24">
              <el-input
                v-model="organization.core_account"
                :readonly="true"
                placeholder="Кор счет"
              />
            </el-col>
            <el-col :span="24">
              <p><b>Номер счета</b></p>
            </el-col>
            <el-col :span="24">
              <el-input
                v-model="organization.checking_account"
                placeholder="Номер счета"
                @blur="checkRs"
              />
              <div v-if="errorRs.code > 0" style="padding-top: 5px; color: red">
                {{ errorRs.message }}
              </div>
              <p><b>Загрузите ИНН</b></p>
              <upload-document-modal
                name-document="ИНН"
                :data-edit="documents.inn"
                :source-id="documents.inn.sourceId"
                :need-additional="false"
              />
              <p><b>Загрузите ОГРН</b></p>
              <upload-document-modal
                name-document="ОГРН"
                :data-edit="documents.ogrn"
                :source-id="documents.ogrn.sourceId"
                :need-additional="false"
              />
            </el-col>
          </el-row>
          <div
            v-if="!isMobile && org.id"
            class="inn-buttons-block"
            style="width: 100% !important"
          >
            <el-alert
              v-if="notes"
              :title="notes"
              type="error"
              center
              show-icon
            />
            <share-link-button
              :is-small-button="false"
              :id-org="12"
              style="margin: 20px"
            />
            <el-button
              v-if="!notes"
              style="margin: 20px"
              type="success"
              @click="updateOrganization"
            >
              Сохранить
            </el-button>
          </div>
        </el-card>
        <div
          v-if="isMobile && org.id"
          class="inn-buttons-block"
          style="width: 100% !important"
        >
          <el-button
            type="warning"
            icon="el-icon-arrow-left"
            style="margin: 20px 0; padding-left: 10px !important"
            @click="$router.push('/user')"
          >
            Назад
          </el-button>
          <el-button
            v-if="!notes"
            style="margin: 20px"
            type="success"
            @click="updateOrganization"
          >
            Сохранить
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_PROFILE } from '@/store/actions/userprofile'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { validateRs } from '@/helpers/validate-req'
import ShareLinkButton from '@/components/Forms/ShareLinkButton'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'
const Check = RepositoryFactory.get('check')
const Organization = RepositoryFactory.get('userOrganizations')

export default {
  name: 'OrgEdit',
  components: { UploadDocumentModal, ShareLinkButton },
  data() {
    return {
      org: '',
      errorRs: {
        code: 0,
        message: '',
      },
      id: 0,
      documents: {
        inn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'inn',
        },
        ogrn: {
          sourceModelName: 'userOrgs',
          sourceId: 0,
          documentType: 'ogrn',
        },
      },
      organization: {
        organization_id: 0,
        is_approve: 0,
        bik: '',
        name_bank: '',
        core_account: '',
        checking_account: '',
      },
      notes: '',
    }
  },

  computed: {
    needAdditional() {
      return this.canAction('additionalCompany')
    },
    //   // перенес в watch

    // org() {
    //   if (!this.id) {
    //     const orgId = this.$route.query.id
    //
    //     if (!orgId || orgId === 'undefined') {
    //       this.$router.push('/user')
    //     }
    //     const t = this.userInfo.profile.user_organizations.filter(
    //       org => Number(org.id) === Number(orgId),
    //     )
    //
    //     if (t.length) {
    //       this.beforeOpen(t[0])
    //
    //       return t[0]
    //     }
    //
    //     return { organization: {} }
    //   }
    //
    //   const t = this.userInfo.profile.user_organizations.filter(org => org.id)
    //
    //   this.beforeOpen(t[0])
    //
    //   return t[0]
    // },
  },
  watch: {
    id: {
      immediate: true,
      handler(value) {
        if (!value) {
          const orgId = this.$route.query.id

          if (!orgId || orgId === 'undefined') {
            this.$router.push('/user')
          }
          const t = this.userInfo.profile.user_organizations.filter(
            org => Number(org.id) === Number(orgId),
          )

          if (t.length) {
            this.beforeOpen(t[0])

            this.org = t[0]
          }

          this.org = { organization: {} }
        }

        const t = this.userInfo.profile.user_organizations.filter(org => org.id)

        this.beforeOpen(t[0])

        this.org = t[0]
      },
    },
  },
  methods: {
    checkRs() {
      if (this.organization.checking_account) {
        this.organization.checking_account =
          this.organization.checking_account.replace(/\s/g, '')
      }

      return validateRs(
        this.organization.checking_account,
        this.organization.bik,
        this.errorRs,
      )
    },
    checkBik() {
      Check.bik(this.organization.bik).then(response => {
        if (response.data && !response.data.error) {
          this.organization.name_bank = response.data.name
            .split('&quot;')
            .join("'")
          this.organization.core_account = response.data.ks
        } else {
          this.organization.name_bank = 'Банк не найден'
        }
      })
    },
    beforeOpen(org) {
      const {
        id,
        organization_id,
        is_approve,
        bik,
        name_bank,
        core_account,
        checking_account,
      } = org

      this.organization = {
        organization_id,
        is_approve,
        bik,
        name_bank,
        core_account,
        checking_account,
      }
      this.id = id
      this.documents.ogrn.sourceId = id
      this.documents.inn.sourceId = id
      this.notes = ''
    },
    updateOrganization() {
      if (this.checkRs()) {
        const data = this.organization

        data.user_id = this.userId
        Organization.updateItem(this.org.id, data)
          .then(res => {
            if (res.data) {
              this.$store.dispatch(`userProfile/${GET_PROFILE}`)
              this.$alert('Данные по компании сохранены успешно').then(() => {
                if (this.isMobile) {
                  this.$router.push('/user')
                }
              })
            }
          })
          .catch(err => {
            const { data } = err

            if (data && data.message) {
              this.notes = data.message
            }
          })
      } else {
        this.$message.warning(this.errorRs.message)
      }
    },
  },
}
</script>

<style lang="sass">
.c-dialog-head
  display: flex
  justify-content: space-between
  align-items: center
  padding-right: 20px
  &__title
    margin: 0
</style>
